import { mapActions } from 'vuex'

const tiempoInactividad = 1800000;
let tiempo; // Declarar la variable tiempo

const InactivityLogout = {
  // Crear un mixin global
    created() {
      window.onload = this.resetearTiempo;
      document.onmousemove = this.resetearTiempo;
      document.onkeydown  = this.resetearTiempo;
    },
    methods: {
      ...mapActions(["logout"]),
      resetearTiempo() {
        clearTimeout(tiempo);
        tiempo = setTimeout(this.logout, tiempoInactividad);
      },
    }
  
}

export default InactivityLogout;